import { useRef } from "react";
import { IoMenu, IoClose } from "react-icons/io5";
import { useTranslator } from "@eo-locale/react";

const HamburgerIcon = ({ onClick, isMobileMenuVisible }) => {
  const metismenuContainer = useRef(null);
  const { translate } = useTranslator();

  if (
    metismenuContainer.current &&
    metismenuContainer.current.classList.contains("display-none")
  ) {
    onClick();
  }

  return (
    <button
      ref={metismenuContainer}
      className="hamburger-icon"
      type="button"
      aria-expanded={isMobileMenuVisible}
      aria-label={translate("common.toggleMainMenu")}
      onClick={onClick}
    >
      {isMobileMenuVisible ? (
        <IoClose aria-expanded="true" />
      ) : (
        <IoMenu aria-expanded="false" />
      )}
    </button>
  );
};

export default HamburgerIcon;
